export const SET_USER_STATE = "SET_USER_STATE";
export const SET_USER_CITY = "SET_USER_CITY";
export const SET_USER_COUNTRY = "SET_USER_COUNTRY";
export const SET_USER_STATE_LIST = "SET_USER_STATE_LIST";
export const SET_CITIES_LIST = "SET_CITIES_LIST";
export const SET_USER_TOP_CITIES = "SET_USER_TOP_CITIES";
export const SET_USER_EXPERIENCE_RANGE = "SET_USER_EXPERIENCE_RANGE";
export const SET_USER_EXPERIENCE_RANGE_CUSTOM =
  "SET_USER_EXPERIENCE_RANGE_CUSTOM";
export const SET_USER_SALARY_RANGE = "SET_USER_SALARY_RANGE";
export const SET_COUNTRY_LIST = "SET_COUNTRY_LIST";
export const SET_EXPERIENCE_SALARY_DATA = "SET_EXPERIENCE_SALARY_DATA";
export const SET_CITY_SALARY_DATA = "SET_CITY_SALARY_DATA";
export const SET_SALARY_RANGE_SKELETON = "SET_SALARY_RANGE_SKELETON";
export const SET_SINGLE_EXPERIENCE_SKELETON = "SET_SINGLE_EXPERIENCE_SKELETON";
export const SET_CITES_RANGE_SKELETON = "SET_CITES_RANGE_SKELETON";
export const SET_SINGLE_CITY_SKELETON = "SET_SINGLE_CITY_SKELETON";
export const SET_SALARY_RANGE_BY_CITIES = "SET_SALARY_RANGE_BY_CITIES";
export const SET_SALARY_RANGE_SKELETON_BOX = "SET_SALARY_RANGE_SKELETON_BOX"

export const setUserState = (state) => ({
  type: SET_USER_STATE,
  payload: state,
});
export const setUserCity = (city) => ({
  type: SET_USER_CITY,
  payload: city,
});

export const setUserCountry = (country) => ({
  type: SET_USER_COUNTRY,
  payload: country,
});
export const setUserStateList = (stateList) => ({
  type: SET_USER_STATE_LIST,
  payload: stateList,
});
export const setUserTopCities = (topCities) => ({
  type: SET_USER_TOP_CITIES,
  payload: topCities,
});
export const setUserExperienceRange = (experienceRange) => ({
  type: SET_USER_EXPERIENCE_RANGE,
  payload: experienceRange,
});
export const setUserExperienceRangeCustom = (experienceRange) => ({
  type: SET_USER_EXPERIENCE_RANGE_CUSTOM,
  payload: experienceRange,
});

export const setSalaryRange = (salaryRange) => ({
  type: SET_USER_SALARY_RANGE,
  payload: salaryRange,
});

export const setCountryList = (countries) => ({
  type: SET_COUNTRY_LIST,
  payload: countries,
});

export const setExperienceSalaryData = (experienceSalaryData) => ({
  type: "SET_EXPERIENCE_SALARY_DATA",
  payload: experienceSalaryData,
});

export const setCitySalaryData = (citySalaryData) => ({
  type: "SET_CITY_SALARY_DATA",
  payload: citySalaryData,
});

export const setSalaryRangeSkeleton = (loading) => ({
  type: SET_SALARY_RANGE_SKELETON,
  payload: loading,
});

export const setSingleSkeleton = (loading) => ({
  type: SET_SINGLE_EXPERIENCE_SKELETON,
  payload: loading,
});

export const setSalaryRangeByCities = (salaryRangeData) => ({
  type: SET_SALARY_RANGE_BY_CITIES,
  payload: salaryRangeData,
});

export const setSingleCitySkeleton = (loading) => ({
  type: SET_SINGLE_CITY_SKELETON,
  payload: loading,
});

export const setCitiesRangeSkeleton = (loading) => ({
  type: SET_CITES_RANGE_SKELETON,
  payload: loading,
});

export const setCitiesList = (cityList) => ({
  type: SET_CITIES_LIST,
  payload: cityList,
});

export const setSalaryRangeSkeletonBox = (loading)=>({
  type:SET_SALARY_RANGE_SKELETON_BOX,
  payload:loading
})